import { Wizard } from '@/components/layout/Wizard';
import { Background, Container } from '@/components/wm';
import { getStoreResource, setStoreResource } from '@/utils/store';
import React from 'react';
import { Schedule } from '../Schedule';
import { Properties } from './Content/Properties';

export default function CreateAlarm ({ indicatorId = '' }) {
    const initialData = {
        indicatorId: indicatorId || null,
        maxValue: 0,
        minValue: 0,
        name: '',
        type: 'instantaneous',
        schedule: {},
        userIds: []
    };

    const steps = [
        { Component: Properties, title: i18next.t('modal.title.alarms.new') },
        { Component: Schedule, title: i18next.t('modal.title.alarm_schedules.new') }
    ];

    const handleSubmit = async data => {
        const indicator = getStoreResource('indicators', data.indicatorId);

        if (indicator.unit === 'Wh')        {
            data.minValue = data.minValue * 1000;
            data.maxValue = data.maxValue * 1000;
        }

        let finalData = {
            indicator_id: data.indicatorId,
            type: data.type,
            user_ids: data.userIds
        };

        if (data.type !== 'baseline') {
            finalData.name = data.name;
            finalData.max_value = data.maxValue;
            finalData.min_value = data.minValue;
            finalData.schedule = data.schedule;
        }

        return await setStoreResource('alarms', finalData);
    };

    return (
        <Background>
            <Container>
                <Wizard
                    handleSubmit={handleSubmit}
                    initialData={initialData}
                    steps={steps}
                />
            </Container>
        </Background>
    );
}
